import React from 'react';
import { FormattedMessage } from 'utils';

export const CountryCodeLabelMessage = (
  <FormattedMessage id="formLabel.countryCode" defaultMessage="Country Code (2-letter, uppercase)" />
);
